//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {addToClipboard} from "~/helpers/clipboard";

export default {

  data: function () {
    return {
      expanded: [],
      active: '',
      isOpen: true
    }
  },

  props: {
    menu: {
      type: Array,
      default: () => {
        return []
      }
    }
  },

  mounted: function () {
    const options = {
      root: null,
      rootMargin: '130px 0px 0px 0px',
      threshold: 0.6
    }

    const observer = new IntersectionObserver(this.watchScroll, options);
    const targets = document.querySelectorAll('.parent-info-card-doc-v2');
    targets.forEach(t => observer.observe(t))

    this.active = this.menu?.[0]?.items?.[0]?.sectionKey;
  },

  methods: {
    changeOpen: function () {
      this.isOpen = !this.isOpen;
    },
    watchScroll: function (entries) {
      const self = this;
      entries.forEach(entry => {
        if (entry.intersectionRatio > 0) {
          self.active = entry.target.dataset.keySection;
        }
      });
    },

    clickSection: async function (key, isPopup) {
      const element = document.querySelector(`[data-key-section="${ key }"]`);
      if (!element) {
        return
      }

      if (Boolean(Number.parseFloat(isPopup || '0'))) {
        element.querySelector('.parent-info-card-doc-v2__button-modal').click();

        const pathname = String(window.location?.href || "").split("#")?.[0];
        await addToClipboard([pathname, key].join('#'));
        window.history.replaceState(null, null, [pathname, key].join('#'));

        return;
      }

      const headerHeight = document.getElementById('siteHeader').getBoundingClientRect().height;
      const topScroll = element.getBoundingClientRect()?.top;

      document.getElementById('scroll-container').scrollTo({
        top: topScroll - headerHeight - 20 + document.getElementById('scroll-container').scrollTop
      });
    },

    changeExpanded: function (label) {
      let expanded = [...this.expanded];
      let index = expanded.findIndex((t) => Boolean(label === t));
      if (index > -1) {
        expanded.splice(index, 1)
      } else {
        expanded.push(label)
      }
      this.expanded = expanded;
    },
  }

}
